"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSettingsValues(values, params) {
    var acc = {};
    Object.keys(params).forEach(function (paramKey) {
        var param = params[paramKey];
        if (typeof values[param.key] !== 'undefined') {
            acc[param.key] = values[param.key];
        }
        else {
            acc[param.key] = param.getDefaultValue();
        }
    });
    return acc;
}
exports.getSettingsValues = getSettingsValues;
//# sourceMappingURL=getSettingsValues.js.map